<template>
  <mds-combo-box
    v-model="selectedFixedDay"
    :label="translate('frequency.modal.weekly.label')"
    :data-set="dataSet"
    :selected-items="selectedFixedDay"
    @input="emitWeeklyFrequency"
  />
</template>

<script>
import MdsComboBox from '@mds/combo-box'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import { dayList } from '@/utils/getter'
import defaultConfig from '@/components/frequencyModal/config/i18n'

export default {
  name: 'WeeklyFrequency',
  components: {
    MdsComboBox,
  },
  props: {
    fixedDay: {
      type: String,
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
      dataSet: dayList(),
      selectedFixedDay: [],
    }
  },
  created() {
    this.selectedFixedDay = this.fixedDayExists(this.fixedDay)
      ? [this.fixedDay]
      : ['Mon']

    this.emitWeeklyFrequency(this.selectedFixedDay)
  },
  methods: {
    fixedDayExists(fixedDay) {
      return Object.values(this.dataSet).some((day) => day.value === fixedDay)
    },
    emitWeeklyFrequency(e) {
      this.$emit('input', { fixedDay: e[0] })
    },
  },
}
</script>
